export default __webpack_public_path__ + "static/media/Cross.f3780803.png";